<template>
  <div class="question-container">
    <div class="question-type">多选</div>
    <div class="title-view">
      <!-- <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span
        >{{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <span
            style="
              position: relative;
              top: -2px;
              padding: 0 8px;
              line-height: 20px;
              background: rgba(58, 96, 255, 0.09);
              border: 1px solid rgba(58, 96, 255, 0.4);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
              color: #3a60ff;
              display: inline-block;
              margin-left: 10px;
            "
          >
            {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分
          </span>
        </span>
      </span> -->

      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
          <span
            style="
              position: relative;
              padding: 0 8px;
              line-height: 20px;
              background: rgba(58, 96, 255, 0.09);
              border: 1px solid rgba(58, 96, 255, 0.4);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
              color: #3a60ff;
              display: inline-block;
              margin-left: 10px;
            "
          >
            {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分
          </span>
        </span>
      </p>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div v-for="(item, idx) in list" :key="idx">
      <div v-if="showAnswer">
        <div
          v-if="item.color == '1'"
          class="choose-css"
          style="
            border: 1px solid rgba(74, 115, 247, 0.5);
            background: rgba(74, 115, 247, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(58, 96, 255, 1);
            "
          >
            {{ item.id + "、" + item.text }}
          </span>
          <div style="display: flex; align-items: center">
            <div class="true-answer" style="color: #00c755">
              {{ item.isCorrect ? "正确答案" : "" }}
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div
          v-if="item.color == '2'"
          class="choose-css"
          style="
            border: 1px solid rgba(247, 59, 66, 0.5);
            background: rgba(247, 59, 66, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(247, 59, 66, 1);
            "
          >
            {{ item.id + "、" + item.text }}
          </span>
          <div style="display: flex; align-items: center">
            <div class="true-answer" style="color: #00c755">
              {{ item.isCorrect ? "正确答案" : "" }}
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747885842739.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div
          v-if="item.color == '3'"
          class="choose-css"
          style="
            border: 1px solid rgba(0, 199, 85, 0.5);
            background: rgba(0, 199, 85, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(58, 96, 255, 1);
            "
          >
            {{ item.id + "、" + item.text }}
          </span>
          <div style="display: flex; align-items: center">
            <div class="true-answer" style="color: #00c755">
              {{ item.isCorrect ? "正确答案" : "" }}
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747885970303.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div
          v-if="item.color == '4'"
          class="choose-css"
          style="
            border: 1px solid rgba(255, 172, 58, 0.5);
            background: rgba(255, 172, 58, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(58, 96, 255, 1);
            "
          >
            {{ item.id + "、" + item.text }}
          </span>
          <div style="display: flex; align-items: center">
            <div class="true-answer" style="color: #00c755">
              {{ item.isCorrect ? "正确答案" : "" }}
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747885864346.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div
          v-if="item.color == '0'"
          class="choose-css"
          style="
            border: 1px solid rgba(237, 237, 237, 1);
            background: rgba(247, 247, 247, 1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(43, 47, 54, 1);
            "
          >
            {{ item.id + "、" + item.text }}
          </span>
          <div style="display: flex; align-items: center">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747892286609.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="choose-css choose-css-new"
        :style="{
          border: item.isChoose
            ? `1px solid rgba(${themeColor.r},${themeColor.g},${themeColor.b},0.5)`
            : '1px solid rgba(237,237,237,0.5)',
          background: item.isChoose
            ? `rgba(${themeColor.r},${themeColor.g},${themeColor.b},0.1)`
            : 'rgba(247,247,247,1)',
        }"
        @click="handleChoose(item, idx)"
      >
        <div class="choose-css-text">
          <span
            style="white-space: normal; word-break: break-all"
            :style="{
              color: item.isChoose
                ? `rgba(${themeColor.r},${themeColor.g},${themeColor.b},1)`
                : 'rgba(43,47,54,1)',
              fontWeight: item.isChoose ? 'bold' : 'normal',
            }"
          >
            {{
              (isEmpty(item.id) ? optionLetters[idx] : item.id) +
              "、" +
              item.text
            }}
          </span>
          <div style="display: flex; align-items: center">
            <div class="true-answer">
              {{ item.isCorrect ? "正确答案" : "" }}
            </div>
            <img
              v-if="dataObj.status === 4"
              :src="
                item.isChoose
                  ? 'https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg'
                  : 'https://ossfastmake.mustke.com/qrCode/tupian/1747892286609.svg'
              "
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div class="question-images">
          <div
            class="question-images-box"
            @click.stop="showBigImage(imgItem, item)"
            v-for="(imgItem, imgIndex) in item.img_path"
            :key="imgIndex"
            style="margin-top: 20px; position: relative"
          >
            <img :src="imgItem" class="thumbnail-image" />
            <div class="fangda-box">查看图片</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAnswer">
      <div
        v-if="dataObj.ifRight"
        style="display: flex; align-items: center; margin-top: 20px"
      >
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335507420.svg"
          style="width: 15px; height: 15px"
        />
        <span class="correct-text">回答正确 +{{ dataObj.score }}分</span>
      </div>
      <div v-else style="display: flex; align-items: center; margin-top: 20px">
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335577224.svg"
          style="width: 15px; height: 15px"
        />
        <span class="error-text" style="font-size: 15px; font-weight: 500"
          >答错了
          {{ dataObj.score > 0 ? `+${dataObj.score}分` : "" }}
        </span>
      </div>
      <div v-if="!dataObj.ifRight" style="margin-top: 10px">
        <span
          style="
            font-size: 15px;
            font-weight: 500;
            text-align: left;
            color: #00c755;
          "
          >正确答案</span
        >
        <div
          style="
            width: 100%;
            padding: 13px;
            box-sizing: border-box;
            background: #f7f7f7;
            border: 1px solid #ededed;
            border-radius: 3px;
            margin-top: 10px;
          "
        >
          {{ dataObj.chooseAnswer }}
        </div>
      </div>
      <div class="explanation-section" style="margin-top: 10px">
        <span class="section-title" style="font-size: 15px; font-weight: 500"
          >答案解析</span
        >
        <div class="textarea-view" style="margin-top: 10px">
          {{ dataObj.analysis || "暂无内容" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewMCQ",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      index: 0,
      minCount: 1,
      maxCount: 1,
      themeColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      images: [],
      showState: 0,
      optionLetters: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      dataObj: {},
    };
  },
  watch: {
    params: {
      handler(newValue) {
        console.log("newValue999999999999999", newValue);

        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.showState = newValue.state;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          const chooseList = JSON.parse(newValue.data.chooseList);
          this.list = chooseList.list;
          this.minCount = chooseList.minCount;
          this.maxCount = chooseList.maxCount;

          console.log("qwewe12e\[12e12\e12]", this.list);

          // if (newValue.theme !== null) {
          //   this.themeColor = {
          //     r: newValue.theme.themeColor.r,
          //     g: newValue.theme.themeColor.g,
          //     b: newValue.theme.themeColor.b,
          //   };
          // }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleChoose(item, index) {
      if (this.dataObj.data.status === 4 || this.dataObj.data.status === 3) {
        this.list[index].isChoose = !item.isChoose;

        const updatedData = {
          ...this.dataObj.data,
          chooseList: JSON.stringify({
            list: this.list,
            minCount: this.minCount,
            maxCount: this.maxCount,
          }),
        };

        this.$emit(
          "update",
          JSON.stringify({
            data: updatedData,
            index: this.index,
            answer: {
              question_id: this.dataObj.data.id,
              type: this.dataObj.data.type,
              if_hide: this.dataObj.data.if_hide,
              answer: this.list
                .filter((item) => item.isChoose === true)
                .map((item) => ({
                  id: item.id,
                  context: item.fill_prompt,
                })),
            },
          }),
        );
      }
    },
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text;
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
    isEmpty(value) {
      return value === null || value === undefined || value === "";
    },
  },
};
</script>

<style lang="scss" scoped>
.question-container {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  // padding: 20px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
  position: relative;
}

.title-view {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
  word-break: break-all;
  margin-top: 0;
  width: 90%;
}

.asterisk {
  color: #f73b42;
  margin-right: 4px;
}

.question-images {
  img {
    width: 100%;
    display: block;
    margin-top: 15px;
  }
}

.choose-css {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.choose-css-new {
  &:hover {
    opacity: 0.8;
  }
}

.choose-css-text {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.true-answer {
  font-size: 14px;
  color: #00c755;
  margin-right: 10px;
}

.correct-text {
  font-size: 15px;
  font-weight: 500;
  color: #00c755;
  margin-left: 8px;
}

.error-text {
  font-size: 15px;
  font-weight: 500;
  color: #f73b42;
  margin-left: 8px;
}

.explanation-section {
  margin-top: 20px;

  .section-title {
    font-size: 15px;
    font-weight: 500;
    color: #2b2f36;
    display: block;
    margin-bottom: 10px;
  }
}

.textarea-view {
  width: 100%;
  min-height: 100px;
  max-height: 200px;
  overflow-y: auto;
  // background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  word-break: break-all;
  line-height: 1.6;
  text-align: left;
}

.textarea-placeholder {
  color: #c0c4cc;
}

.question-images-box {
  position: relative;
  cursor: pointer;
  margin-top: 15px;

  .thumbnail-image {
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  .fangda-box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    text-align: center;
    padding: 8px;
    font-size: 12px;
    border-radius: 0 0 8px 8px;
  }
}

.fangda-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-content {
    background: white;
    border-radius: 8px;
    padding: 20px;
    max-width: 90%;
    max-height: 90%;
    position: relative;

    .popup-guanbi {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .popup-scroll {
      max-height: 80vh;
      overflow-y: auto;

      img {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}

.guanbi {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewSCQ.vue